import queryString from "query-string";
import {defaultVariabls} from "./index";
import {Translate} from "./Translate";
import {getStore} from "trim-redux";

export const howToSale = ["روش فروش ۵","روش فروش ۴","روش فروش ۳","روش فروش ۲","روش فروش ۱"];

export function toEnglishDigits(str) {

    let  e = '۰'.charCodeAt(0);
    str = str.replace(/[۰-۹]/g, function(t) {
        return t.charCodeAt(0) - e;
    });
    return str;
}

export function price(x) {
    if(!!x){
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }else {
        return x
    }
}
export function showPrice(x) {
    if(x > 0){
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")+" "+currencySymbol;
    }else if(x === 0){
        return Translate.free_pricing
    } else {
        return x
    }
}
export function truncate(str, n){
    if(!!str){
        return (str.length > n) ? str.substr(0, n-1) + '...' : str;
    }else{
        return ''
    }
}

export function changeURL(queryStrong) {
    let url = queryString.stringifyUrl({url: window.location.href, query: queryStrong});
    window.history.replaceState(null, "",url);
}

export const currencySymbol = 'تومان';

export const AddressesLimit = 5;

export function getComplexFileUrl(file,size = ''){
    if(!!file){
        if(!!file.thumbnail){
            return file.thumbnail
        }else if(!!file.src){
            return file.src
        }else{
            return  `${defaultVariabls.uploads}/FileManager/${file.name}${size}.${file.extension}`
        }
    }
    return "";

}
export const colors = {
    "need_verification": "#383f53",
    "not_payed": "#ff7d00",
    "gathering": "#383f53",
    "pending": "#383f53",
    "sending": "#c800ff",
    "ready": "#c800ff",
    "rejected": "#ff0000",
    "done": "#05b71d",
    "payed_to_shop": "#00bdc4",
    "received": "#00bdc4",
    "confirmed": "#38bf84",
    "unConfirmed": "#737373",
    "sent": "#58b956",
    "read": "#51a5b9",
    "unread": "#b9554e",
    "closed": "#929292",
}
export const userCanMakeVirtualBook = () => {
    let user = getStore('user');
    if(user.role.type === "admin"){
        return true;
    }
    if(!!user.shops[0]){
        if(user.shops[0].type === "publisher"){
            return true;
        }
    }
    return false
}
export const imgSize= '۵ مگابایت';
export const worked_statuses = ["در حد نو","قابل خواندن","دارای پاره‌گی جلد","صفحاتی از کتاب موجود نیست","صفحاتی از کتاب دارای پاره‌گی و خط خوردگی است"];

export function getMediaURL(media,size = ""){
    if(!!media){
        return `${defaultVariabls.uploads}/FileManager/${media.name}${!size ? "" : "_"+size}.${media.extension}`;
    }else{
        return `${defaultVariabls.uploads}/FileManager/default${!size ? "" : "_"+size}.jpg`
    }
}